import { UserSettingsModelDto as BoUserSettingsDto } from '@treasury/api/bo';
import {
    AccountSummaryModelDto,
    UserSettingsModelDto as ChannelUserSettingsDto,
} from '@treasury/api/channel';
import { DomainEntity } from '../../shared';
import { defaultAccountSummaryModelDto } from '../data/accounts.data';
import { Transaction } from './transaction.entity';

/**
 * Client-side user settings type.
 *
 * For now, alias the types until requirements require something more abstract.
 */
export type UserSettings = BoUserSettingsDto & ChannelUserSettingsDto;

export class Account extends DomainEntity<AccountSummaryModelDto> {
    constructor(public source = defaultAccountSummaryModelDto) {
        super(source);
    }

    public createDefault(): this {
        return new Account(defaultAccountSummaryModelDto) as this;
    }

    public get id() {
        return this.source.id;
    }

    public get number() {
        return this.source.number;
    }

    public get type() {
        return this.source.type;
    }

    public get name() {
        return this.source.name;
    }

    public set name(value: string | undefined) {
        this.source.name = value;
    }

    public get displayLabel() {
        return this.source.accountDisplayLabel;
    }

    public get currentBalance() {
        return this.source.currentBalance;
    }

    public get availableBalance() {
        return this.source.availableBalance;
    }

    public get collectedBalance() {
        return this.source.collectedBalance;
    }

    public get balanceHistory() {
        return this.source.balanceHistory;
    }

    public get transactions() {
        return this.source.transactions?.map(t => new Transaction(t)) ?? [];
    }

    public getTransaction(id: number) {
        return this.transactions.find(t => t.id === id);
    }

    public get status() {
        return this.source.status;
    }

    public get interestRate() {
        return this.source.interestRate;
    }

    public get accruedInterest() {
        return this.source.accruedInterest;
    }

    public get interestPaidYtd() {
        return this.source.interestPaidYtd;
    }

    public get interestPaidPreviousYtd() {
        return this.source.interestPaidPreviousYtd;
    }
}
